export const midLinks = [
  {
    name: "How it Works",
    link: ""
  },

  {
    name: "Get Started",
    link: "/get-started"
  },
  {
    name: "Find an event",
    link: "/find-registry"
  }
]

export const authLink = [
  { name: "Log In", link: "/login" },
  {
    name: "Sign up",
    link: "/sign-up"
  }
]

export const loggedInUserLink = [
  { name: "Dashboard", link: "/dashboard" },
  { name: "Create Event", link: "/create-event" }
]

// Dashboard Menus Links

export const dashMidLinks = [
  {
    name: "Dashboard",
    link: "/dashboard"
  },
  { name: "Checklist", link: "/checklist" },
  { name: "Gift Tracker", link: "/gift-tracker" }
]

export const dashEndLinks = [
  { name: "New Event", link: "/create-event" },
  { name: "Settings", link: "" },
  { name: "Logout", link: "" }
]
